<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="保单号">
                            <Input v-model.trim="params.policyNo" clearable placeholder="请输入保单号" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="姓名">
                            <Input v-model.trim="params.name" clearable placeholder="请输入姓名" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="身份证号">
                            <Input v-model.trim="params.idNo" clearable placeholder="请输入身份证号" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保障状态">
                            <Select v-model="params.status" clearable>
                                <Option value="1">待生效</Option>
                                <Option value="2">保障中</Option>
                                <Option value="3">已失效</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保障起期">
                            <DatePicker type="date" v-model="params.beginDate" placeholder="请选择" style="width: 100%" @on-change="val => params.beginDate = val"></DatePicker>
                        </Form-item>
                    </Col>
                    <Col span="8"> 
                        <Form-item label="保障止期">
                            <DatePicker type="date" v-model="params.endDate" placeholder="请选择" style="width: 100%" @on-change="val => params.endDate = val"></DatePicker>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="创建时间">
                            <daterange @on-change="val=>{setDateRange(val,'createTime')}" placeholder="请选择创建时间" placement="bottom-end" isFulltime></daterange>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="是否自动续保">
                            <Select v-model="params.autoRenewal" clearable>
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </Form-item>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" class="left">
                        <Button type="primary" @click="batchReplace">批量替换</Button>
                        <Button type="primary" @click="batchCancelRenewal">批量取消续保</Button>
                    </Col>
                    <Col span="12" class="right">
                        <Button type="primary" @click="search">查询</Button>
                        <Button type="primary" @click="exportToExcel('/casual/policy/user/list/export',params)">导出</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/casual/policy/user/detail.json.dst" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer v-if="row.status=='1'||row.status=='2'">
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item name="编辑" v-if="row.status=='1'||row.status=='2'" @click.native="editPersonnel(row)" style="text-align: center;">
                                <a>编辑</a>
                            </Dropdown-item>
                            <Dropdown-item v-if="row.status=='1'"  @click.native="batchReduce(row)" style="text-align: center;">
                                <a>批减</a>
                            </Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>

        <!-- 编辑人员信息弹窗 -->
        <Modal v-model="editShow" title="编辑人员信息" :mask-closable="false" width="600">
            <Form :model="editForm" ref="editForm" :label-width="100" :rules="editFormRules">
                <div class="edit-form">
                    <div>原人员信息</div>
                    <Row class="mt20">
                        <Col span="12">
                            <FormItem label="姓名：">
                                {{editForm.name}}
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="身份证号：">
                                {{editForm.idNo}}
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="性别：">
                                {{editForm.genderName}}
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="年龄：">
                                {{editForm.age}}
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="保障方案：">
                                {{editForm.insurancePlanName}}
                            </FormItem>
                        </Col>
                    </Row> 
                </div>
                <div class="mt20">
                    <div>替换后人员信息</div>
                    <FormItem label="姓名" prop="newName" class="mt20">
                        <Input style="width: 300px;" v-model="editForm.newName" placeholder="请输入姓名"></Input>
                    </FormItem>
                </div>
            </Form>
            <div slot="footer">
                <Button @click="editShow=false">取消</Button>
                <Button type="primary" @click="confirmEdit" :loading="editSubmitLoading" :disabled="editSubmitLoading">提交</Button>
            </div>
        </Modal>

        <!-- 批量替换弹窗 -->
        <Modal v-model="batchReplaceShow" title="批量替换" :mask-closable="false" width="60%">
            <div class="mb20">
                <div class="flex">
                    <div>
                        <span>人员信息：</span>
                        <UploadFile
                            style="display:inline-block"
                            url="/pc/casual/policy/change/import"
                            :show-upload-list="false"
                            :data="uploadParams"
                            btn-text="上传人员"
                            @on-success="uploadSuccess"
                            class="ml10" />
                        <span class="ml15">点击<a @click="downloadTemplate" class="text-primary">下载</a>批单模板</span>
                    </div>
                    <div v-if="replaceData.length > 0">
                        <Button type="error" @click="clearPersonnel">清空已上传人员信息</Button>
                    </div>
                </div>
                <p class="mt15" style="color: red;">注意:保障止期当天不允许替换</p>
            </div>
            
            <Table class="mt15" :columns="replaceColumns" :data="replaceData" border>
                <template slot-scope="{ index }" slot="operation">
                    <a @click="deleteReplaceItem(index)">删除</a>
                </template>
            </Table>
            
            <div slot="footer">
                <Button @click="batchReplaceClose">取消</Button>
                <Button type="primary" @click="confirmBatchReplace" :loading="batchReplaceLoading" :disabled="batchReplaceLoading">提交</Button>
            </div>
        </Modal>
        <!-- 价格确认弹窗 -->
        <Modal v-model="priceConfirmShow" title="提示" :mask-closable="false" width="500">
            <div v-if="priceData">
                <p class="mt10 center">本次替换人员，合计需缴纳：{{priceData.amount}}元</p>
                <p class="mt10 center">确认提交信息?</p>
            </div>
            <div slot="footer">
                <Button @click="priceConfirmClose">取消</Button>
                <Button type="primary" @click="confirmPriceSubmit" :loading="priceSubmitLoading" :disabled="priceSubmitLoading">确认提交</Button>
            </div>
        </Modal>
        <!-- 批减确认弹窗 -->
        <Modal v-model="batchReduceShow" title="提示" :mask-closable="false" width="400">
            <p class="mt10 center">本次批减人员,原保单需退费：{{batchReduceForm.premium}}元</p>
            <p class="mt10 center">确认提交信息?</p>
            <div slot="footer">
                <Button @click="batchReduceShow=false">取消</Button>
                <Button type="primary" @click="confirmBatchReduce" :loading="batchReduceLoading" :disabled="batchReduceLoading">提交</Button>
            </div>
        </Modal>

        <!-- 批量取消续保弹窗 -->
        <Modal v-model="batchCancelRenewalShow" title="批量取消续保" :mask-closable="false" width="800" @on-cancel="batchCancelRenewalClose">
            <div class="mb20">
                <div class="flex">
                    <div>
                        <span>人员信息：</span>
                        <UploadFile
                            style="display:inline-block"
                            url="/pc/casual/policy/auto/renewal/import"
                            :show-upload-list="false"
                            :data="uploadParams"
                            btn-text="上传人员"
                            @on-success="cancelRenewalUploadSuccess"
                            class="ml10" />
                        <span class="ml15">点击<a @click="downloadCancelRenewalTemplate" class="text-primary">下载</a>批量模板</span>
                    </div>
                    <div v-if="cancelRenewalData.length > 0">
                        <Button type="error" @click="clearCancelRenewalPersonnel">清空已上传人员信息</Button>
                    </div>
                </div>
                <p class="mt15" style="color: red;">说明：请上传方案一：人保健康险100万保障需要取消续保的人员信息</p>
            </div>
            
            <Table class="mt15" :columns="cancelRenewalColumns" :data="cancelRenewalData" border>
                <template slot-scope="{ row }" slot="checkResult">
                    <span v-if="row.success" class="text-success">通过</span>
                    <span v-else class="text-error">{{ row.msg }}</span>
                </template>
                <template slot-scope="{ index }" slot="operation">
                    <a @click="deleteCancelRenewalItem(index)">删除</a>
                </template>
            </Table>
            
            <div slot="footer">
                <Button @click="batchCancelRenewalClose">取消</Button>
                <Button type="primary" @click="confirmBatchCancelRenewal" :loading="batchCancelRenewalLoading" :disabled="batchCancelRenewalLoading">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'
import UploadFileImg from '@/components/common/UploadFileImg'
import UploadFile from '@/pages/haierProduct/components/common/UploadFile'

export default {
    name: 'personnelDetail',
    components: { ITable, daterange, UploadFileImg, UploadFile },
    data() {
        return {
            params: {},
            columns: [
                { title: '保单号', key: 'policyNo', minWidth: this.$columnW.XL, fixed: 'left' },
                { title: '参保公司', key: 'companyName', minWidth: this.$columnW.XL },
                { title: '姓名', key: 'name', minWidth: this.$columnW.M },
                { title: '身份证号', key: 'idNo', minWidth: this.$columnW.XL,align: 'right'},
                { title: '年龄', key: 'age', minWidth: this.$columnW.M, align: 'right' },
                { title: '性别', key: 'genderName', minWidth: this.$columnW.M },
                { title: '保障方案', key: 'insurancePlanName', minWidth: this.$columnW.XL, ellipsis: true, tooltip: true },
                { title: '保费(元)', key: 'premium',minWidth: this.$columnW.L, align: 'right' },
                { title: '保障起期', key: 'beginDate', minWidth: this.$columnW.L },
                { title: '保障止期', key: 'endDate', minWidth: this.$columnW.L },
                { title: '保障状态', key: 'statusName', minWidth: this.$columnW.L },
                { title: '是否自动续保', key: 'autoRenewalName', minWidth: this.$columnW.L },
                { title: '备注', key: 'remark', minWidth: this.$columnW.XL },
                {title: '创建时间', key: 'createTime', minWidth: this.$columnW.L},
                {
                    title: '操作',
                    slot: 'action',
                    width: 120,
                    fixed: 'right'
                }
            ],
            // 编辑人员相关
            editShow: false,
            editForm: {
                originalName: '',
                originalIdCard: '',
                originalGender: '',
                originalAge: '',
                originalScheme: '',
                newName: ''
            },
            editFormRules: {
                newName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ]
            },
            // 批量替换相关
            batchReplaceShow: false,
            replaceColumns: [
                { title: '新增人姓名', key: 'changeName', width: this.$columnW.M,fixed: 'left' },
                { title: '新增人身份证号', key: 'beChangeIdNo', minWidth: this.$columnW.XL,align: 'right' },
                { title: '新增人年龄', key: 'changeAge', width: this.$columnW.M,align: 'right' },
                { title: '新增人性别', key: 'changeGenderName', width: this.$columnW.M },
                { title: '被替换姓名', key: 'beChangeName', width: this.$columnW.M },
                { title: '被替换身份证号', key: 'changeIdNo', width: this.$columnW.XL,align: 'right' },
                { title: '被替换性别', key: 'beChangeGenderName', width: this.$columnW.M },
                { title: '被替换年龄', key: 'beChangeAge', width: this.$columnW.M,align: 'right' },
                { title: '保单号', key: 'policyNo', width: this.$columnW.XL,align: 'right' },
                { title: '保障方案', key: 'insurancePlanName', minWidth: this.$columnW.XL,ellipsis: true, tooltip: true },
                { title: '替换费用(元)', key: 'premium', width: this.$columnW.L, align: 'right' },
                { title: '操作', slot: 'operation', width: 80,fixed: 'right'}
            ],
            replaceData: [],
            // 批减相关
            batchReduceShow: false,
            batchReduceForm: {},
            // 价格确认相关
            priceConfirmShow: false,
            priceData: null,
            submitLoading: false,
            currentOperationData: null, // 当前操作的数据
            uploadLoading: false, // 添加上传状态
            uploadParams: {}, // 上传参数
            // 批量取消续保相关
            batchCancelRenewalShow: false,
            cancelRenewalColumns: [
                { title: '校验结果', slot: 'checkResult', width: this.$columnW.M, fixed: 'left' },
                { title: '姓名', key: 'name', width: this.$columnW.M },
                { title: '身份证号', key: 'idNo', minWidth: this.$columnW.XL, align: 'right' },
                { title: '年龄', key: 'age', width: this.$columnW.M, align: 'right' },
                { title: '性别', key: 'genderName', width: this.$columnW.M },
                { title: '保障方案', key: 'insurancePlanName', minWidth: this.$columnW.XL, ellipsis: true, tooltip: true },
                { title: '保单号', key: 'policyNo', width: this.$columnW.XL, align: 'right' },
                { title: '操作', slot: 'operation', width: 80, fixed: 'right' }
            ],
            cancelRenewalData: [],
            // 防重复点击状态
            batchReplaceLoading: false, // 批量替换提交状态
            editSubmitLoading: false, // 编辑提交状态
            batchReduceLoading: false, // 批减提交状态
            priceSubmitLoading: false, // 价格确认提交状态
            batchCancelRenewalLoading: false, // 批量取消续保提交状态
        }
    },
    methods: {
        // 批量替换关闭
        batchReplaceClose(){
            this.batchReplaceShow = false
            this.replaceData = []
        },
        // 价格提示确认关闭
        priceConfirmClose() {
            this.priceConfirmShow = false
            this.batchReplaceShow = false
            this.replaceData = []
        },
        setDateRange(val, key) {
            this.params[key + "Begin"] = val[0]
            this.params[key + "End"] = val[1]
        },
        search() {
            this.$refs.table.getList()
        },
        // 编辑人员
        editPersonnel(row) {
            this.editForm = this.jsonCopy(row);
            this.editShow = true
        },
        confirmEdit() {
            if (this.editSubmitLoading) return // 防止重复点击
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.$Modal.confirm({
                        title: '提示',
                        content: '确认提交?',
                        onOk: () => {
                            this.submitEdit()
                        }
                    })
                }
            })
        },
        submitEdit() {
            this.editSubmitLoading = true
            // 提交编辑信息
            this.$axios.post('/casual/policy/edit/save.json', {
                policyNo: this.editForm.policyNo,
                name: this.editForm.newName,
                idNo: this.editForm.idNo
            }).then(res => {
                this.$Message.success('操作成功')
                this.editShow = false
                this.search()
            }).catch(err => {
                this.editSubmitLoading = false
            }).finally(() => {
                this.editSubmitLoading = false
            })
        },
        // 批量替换
        batchReplace() {
            this.batchReplaceShow = true
        },
        // 上传人员成功回调
        uploadSuccess(res) {
            if (res && res.data.userList && res.data.userList.length > 0) {
                this.replaceData = res.data.userList
            }
        },
        downloadTemplate() {
            window.open('/static/excel/批量替换模版.xlsx')
        },
        clearPersonnel() {
            this.replaceData = []
            this.$Message.success('已清空人员信息')
        },
        deleteReplaceItem(index) {
            this.$Modal.confirm({
                title: '提示',
                content: '确认删除该人员？',
                onOk: () => {
                    this.replaceData.splice(index, 1)
                }
            })
        },
        confirmBatchReplace() {
            if (this.batchReplaceLoading) return // 防止重复点击
            if (this.replaceData.length === 0) {
                this.$Message.warning('请先上传替换人员信息')
                return
            }
            // 先调用价格计算接口
            this.calculatePrice(this.replaceData)
        },
        // 批减
        batchReduce(row) {
            this.batchReduceShow = true;
            this.$nextTick(() => {
                this.batchReduceForm =  this.jsonCopy(row)
            })
        },
        batchReduceClose() {
            this.batchReduceShow = false
        },
        confirmBatchReduce() {
            if (this.batchReduceLoading) return // 防止重复点击
            this.batchReduceLoading = true
            // 提交批减
            this.$axios.post('/casual/policy/reduction/save.json', {
                policyNo: this.batchReduceForm.policyNo,
                idNo: this.batchReduceForm.idNo
            }).then(res => {
                this.batchReduceLoading = false
                this.$Message.success('批减成功')
                this.batchReduceClose()
                this.search()
            }).catch(err => {
                this.batchReduceLoading = false
            }).finally(() => {
                this.batchReduceLoading = false
            })
        },
        // 计算价格（仅用于批量替换）
        calculatePrice(data) {
            this.batchReplaceLoading = true
            this.$axios.post('/casual/policy/change/premium.json', data).then(res => {
                this.batchReplaceLoading = false
                this.priceData = {
                    amount: res.premium || 0
                }
                this.currentOperationData = data // 保存当前操作数据
                this.batchReplaceShow = false
                this.priceConfirmShow = true
            }).catch(err => {
                this.batchReplaceLoading = false
            })
        },
        // 批量替换
        confirmPriceSubmit() {
            if (this.priceSubmitLoading) return // 防止重复点击
            this.priceSubmitLoading = true
            // 保存替换批改单
            this.$axios.post('/casual/policy/change/save.json', {
                premium: this.priceData.amount,
                users: this.currentOperationData
            }).then(res => {
                this.$Message.success('操作成功')
                this.priceConfirmShow = false
                this.batchReplaceShow = false
                this.search()
            }).catch(err => {
                this.priceSubmitLoading = false
            }).finally(() => {
                this.priceSubmitLoading = false
            })
        },
        // 批量取消续保
        batchCancelRenewal() {
            this.batchCancelRenewalShow = true
        },
        // 批量取消续保关闭
        batchCancelRenewalClose() {
            this.batchCancelRenewalShow = false
            this.cancelRenewalData = []
        },
        // 上传取消续保人员成功回调
        cancelRenewalUploadSuccess(res) {
            if (res && res.data.length > 0) {
                this.cancelRenewalData = res.data
            }
        },
        // 下载取消续保模板
        downloadCancelRenewalTemplate() {
            window.open('/static/excel/取消续保导入模版.xlsx', '_blank')
        },
        // 清空取消续保人员
        clearCancelRenewalPersonnel() {
            this.cancelRenewalData = []
            this.$Message.success('已清空人员信息')
        },
        // 删除取消续保人员
        deleteCancelRenewalItem(index) {
            this.$Modal.confirm({
                title: '提示',
                content: '确认删除该人员？',
                onOk: () => {
                    this.cancelRenewalData.splice(index, 1)
                }
            })
        },
        // 确认批量取消续保
        confirmBatchCancelRenewal() {
            if (this.batchCancelRenewalLoading) return // 防止重复点击
            if (this.cancelRenewalData.length === 0) {
                this.$Message.warning('请先上传取消续保人员信息')
                return
            }
            this.batchCancelRenewalLoading = true
            // 提交取消续保
            this.$axios.post('/casual/policy/auto/renewal/cancel.json', this.cancelRenewalData).then(res => {
                this.$Message.success('操作成功')
                this.batchCancelRenewalShow = false
                this.cancelRenewalData = []
                this.search()
            }).catch(err => {
                this.batchCancelRenewalLoading = false
            }).finally(() => {
                this.batchCancelRenewalLoading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.flex{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.text-primary {
    color: #2d8cf0;
    cursor: pointer;
}
.text-success {
    color: #19be6b;
}
.text-error {
    color: #ed4014;
}
/deep/.edit-form .ivu-form-item{
    margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/personnel/index.vue